module.exports = __webpack_public_path__ + "static/ignites-25190179c1de2d242fb836784f73a15f.png";